// extracted by mini-css-extract-plugin
export default {"root":"qSlYYE","disqusCommentsHolder":"ri84OS","noDisqusIdMessage":"JkVQSK"};